import { programRequestsApi } from '../api/programRequestsApi';
import { toCreateSplitRequest } from './splitProgramModel';

export const createSplitProgramFlow = async ({
    form,
    newPrograms,
    onError,
    api = programRequestsApi,
}) => Boolean(
    await api.createSplitRequest(toCreateSplitRequest(form, newPrograms), onError)
);
